import { render, staticRenderFns } from "./EditAttr.vue?vue&type=template&id=412f076a"
import script from "./EditAttr.vue?vue&type=script&lang=js"
export * from "./EditAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports